// src/hooks/useVariables.js
import { useState, useCallback } from 'react';

const defaultVariables = [
  {
    id: 'price_petit_dej',
    name: 'Prix Petit Déjeuner',
    type: 'currency',
    description: 'Prix du petit déjeuner simple',
    defaultValue: '2€80',
    category: 'prix'
  },
  {
    id: 'price_grand_dej',
    name: 'Prix Grand Déjeuner',
    type: 'currency',
    description: 'Prix du grand petit déjeuner',
    defaultValue: '6€50',
    category: 'prix'
  },
  {
    id: 'opening_hours',
    name: 'Horaires d\'ouverture',
    type: 'text',
    description: 'Horaires d\'ouverture du jour',
    defaultValue: 'DE 6H00 A 11H00 DU LUNDI AU SAMEDI',
    category: 'info'
  },
  {
    id: 'special_offer',
    name: 'Offre Spéciale',
    type: 'text',
    description: 'Promotion ou offre du moment',
    defaultValue: 'Découvrez nos nouveautés !',
    category: 'promotion'
  }
];

const useVariables = () => {
  const [variables, setVariables] = useState(defaultVariables);

  const addVariable = useCallback((variableData) => {
    const newVariable = {
      ...variableData,
      id: variableData.id || `var_${Date.now()}`,
    };
    setVariables(prev => [...prev, newVariable]);
    return newVariable;
  }, []);

  const updateVariable = useCallback((variableId, updates) => {
    setVariables(prev => prev.map(variable =>
      variable.id === variableId ? { ...variable, ...updates } : variable
    ));
  }, []);

  const deleteVariable = useCallback((variableId) => {
    setVariables(prev => prev.filter(variable => variable.id !== variableId));
  }, []);

  const getVariableById = useCallback((id) => {
    return variables.find(variable => variable.id === id);
  }, [variables]);

  const getVariablesByCategory = useCallback((category) => {
    return variables.filter(variable => variable.category === category);
  }, [variables]);

  return {
    variables,
    setVariables,
    addVariable,
    updateVariable,
    deleteVariable,
    getVariableById,
    getVariablesByCategory
  };
};

export default useVariables;